module.exports = __webpack_public_path__ + "testimonials_background.d3fd86199c05e0cfbfbf.png";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src154282656/src/www-arthcloud/src/assets/images/landing/testimonials_background.png
// module id = ../../../../../src/assets/images/landing/testimonials_background.png
// module chunks = 2